/**
 * SignalBadge — a salmon-tinted Priorisierungssignal pill (SIGNALE column +
 * detail "PRIORISIERUNGSSIGNALE"). Category/flag soft-badge (design.md §2), so it
 * carries no status semantics — it is a signal marker, not an ampel.
 */

import { cn } from '../../../lib/cn';
import { SIGNAL_LABEL } from '../constants';
import type { KontrolleSignalTyp } from '../types';

export function SignalBadge({ typ, className }: { typ: KontrolleSignalTyp; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border border-signal-border bg-signal-bg px-2 py-0.5 text-xs font-medium text-signal-text',
        className,
      )}
    >
      {SIGNAL_LABEL[typ]}
    </span>
  );
}
